/* 
 * this is not generic persist for redux but just simple session based persist to survive browser refresh 
 */

export function RememberCurrent(key, item) {
    if (key) {
        try {
            sessionStorage.setItem(key,JSON.stringify(item));
        } catch (e) {
            sessionStorage.setItem(key,item);
        }
    }
    else {
        sessionStorage.removeItem(key);
    }
}

export function GetCurrent(key) {
    try {
        return JSON.parse(sessionStorage[key]); 

    } catch (e)
    {
        return sessionStorage[key]; 
    }    
}


// WEBPACK FOOTER //
// ./src/redux/Persist.js